import $ from 'jquery';
import 'bootstrap';
import 'bootstrap-select';
import 'bootstrap-daterangepicker';
import * as bootbox from 'bootbox';

import init, { initJQuery } from './init';
import Utils from './utils';


// Assign stuff to global context
window.$ = $;
window.jQuery = $;
window.Utils = Utils;

// Init
init($);
initJQuery($);

// Export classes
export {
    $,
    init,
    Utils,

    bootbox,
};
